const CDN_URL = import.meta.env.VITE_CDN_URL || ''

export function getImageUrl(key: string, updatedAt?: string): string {
  const url = `${CDN_URL}/${key}`
  if (updatedAt) {
    return `${url}?v=${encodeURIComponent(updatedAt)}`
  }
  return url
}

export function getThumbnailUrl(image: { thumbnailKeys?: { small?: string; medium?: string; large?: string }; updatedAt?: string }, size: 'small' | 'medium' | 'large'): string {
  const key = image.thumbnailKeys?.[size]
  if (!key) return ''
  return getImageUrl(key, image.updatedAt)
}
